"use client";

import type { PillPosition } from "@/lib/pill-counter/claude-vision";

type Props = {
  positions: PillPosition[];
  width: number;
  height: number;
};

/**
 * Absolute-positioned SVG overlay aligned to a preview image (same box as the img).
 * Positions are normalized 0–1 from the vision model.
 */
export function PillDotOverlay({ positions, width, height }: Props) {
  if (width <= 0 || height <= 0 || positions.length === 0) return null;
  const minSide = Math.min(width, height);

  return (
    <svg
      className="ed-pill-dot-overlay"
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width,
        height,
        pointerEvents: "none",
      }}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden
    >
      {positions.map((p, i) => {
        const cx = p.x * width;
        const cy = p.y * height;
        const r = Math.max(2, p.radius * minSide);
        return (
          <circle
            key={`dot-${i}`}
            cx={cx}
            cy={cy}
            r={r}
            fill="rgba(34, 197, 94, 0.28)"
            stroke="rgba(22, 163, 74, 0.95)"
            strokeWidth={2}
          />
        );
      })}
    </svg>
  );
}
